import {
  createBroadcastChannel,
  getBroadcastChannelId,
  isBroadcastChannelMessageFromCurrentWindow,
  postBroadcastMessage,
} from '../broadcastChannel';

export const AUTH_CHANNEL_NAME = 'auth';
export const LOGIN_NOTIFICATION_STORAGE_KEY = 'pluto.auth.login-notification';

export type AuthEventType = 'LOGIN' | 'LOGOUT';

type AuthEvent = {
  type: AuthEventType;
  broadcastChannelId: string;
};

function isAuthEvent(value: unknown): value is AuthEvent {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const event = value as { type?: unknown; broadcastChannelId?: unknown };
  return (event.type === 'LOGIN' || event.type === 'LOGOUT') && typeof event.broadcastChannelId === 'string';
}

export function createAuthChannel(): BroadcastChannel | undefined {
  return createBroadcastChannel(AUTH_CHANNEL_NAME);
}

export function postAuthEvent(type: AuthEventType) {
  postBroadcastMessage(AUTH_CHANNEL_NAME, { type, broadcastChannelId: getBroadcastChannelId() } satisfies AuthEvent);
}

export function isAuthEventMessage(value: unknown): value is AuthEvent {
  return isAuthEvent(value);
}

export function isAuthEventFromCurrentWindow(event: AuthEvent) {
  return isBroadcastChannelMessageFromCurrentWindow(event.broadcastChannelId);
}

export function rememberLoginNotification() {
  try {
    sessionStorage.setItem(LOGIN_NOTIFICATION_STORAGE_KEY, 'true');
  } catch {
    // sessionStorage can be unavailable in privacy-restricted browser contexts.
  }
}

export function consumeLoginNotification(): boolean {
  try {
    const shouldNotify = sessionStorage.getItem(LOGIN_NOTIFICATION_STORAGE_KEY) === 'true';
    if (shouldNotify) {
      sessionStorage.removeItem(LOGIN_NOTIFICATION_STORAGE_KEY);
    }
    return shouldNotify;
  } catch {
    return false;
  }
}

export function removeLogoutReason() {
  const url = new URL(window.location.href);
  url.searchParams.delete('reason');
  window.history.replaceState(null, '', url);
}

export function getLogoutUrl() {
  const base = typeof BASE === 'string' && BASE ? BASE : '/';
  const url = new URL(window.location.href);
  url.pathname = `${base.replace(/\/$/, '')}/login`;
  url.search = '?reason=logout';
  url.hash = '';
  return url.toString();
}
